import * as types from "./types";
import { setInitialState } from "../../../stores/InitialState";

const INITIAL_STATE = setInitialState({
    data: null,
    isFetching: false,
    isSuccess: false,
    isError: false,
    error: false
});

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.NEWS_LIST_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.NEWS_LIST_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                data: action.payload
            };
        case types.NEWS_LIST_FAILURE:
            if (action.error && action.payload.name === "RequestError") {
                return {
                    ...state,
                    isError: true,
                    isFetching: false,
                    data: { message: "INTERNET_OFFLINE_MESSAGE" }
                };
            } else {
                return {
                    ...state,
                    isFetching: false,
                    isError: true,
                    isSuccess: false,
                    data: action.payload.response.error,
                };
            };
        case types.RESET_NEWS_LIST:
            return {
                ...state,
                isFetching: false,
                isError: false,
                data: null,
            };
        case types.NEWS_DETAILS_REQUEST:
            return {
                ...state,
                isFetching: true,
                isError: false,
                isSuccess: false,
            };
        case types.NEWS_DETAILS_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                data: action.payload
            };
        case types.NEWS_DETAILS_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                isSuccess: false,
                data: action.payload,
            };
        case types.RESET_NEWS_DETAILS:
            return {
                ...state,
                isFetching: false,
                isError: false,
                data: null,
            };
        default:
            return {
                ...state
            }
    }
}
